<rt-assistant-list-card>
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="link"
      color="colorIconDefault"
      background="colorBgNeutralDefault"
    />
    <span class="label">{{ data().label }}</span>
  </div>
</rt-assistant-list-card>
